var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['switch-container']},_vm._l((_vm.btnLists),function(item,index){return _c('div',{key:index,class:[_vm.$style.btn, _vm.currentIndex === index ? _vm.$style.current : ''],on:{"click":function($event){return _vm.changBtnHandle(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }